import React from 'react';
import ContentSlider from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-slider';
import { ContentSliderProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-slider/types';

interface Props {
  children?: React.ReactNode;
  data: ContentSliderProps;
}

const ContentSliderTastic: React.FC<Props> = ({ data }) => {
  return <ContentSlider {...data} />;
};

export default ContentSliderTastic;
